import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Plus } from '../Icons';

export const faqGroups = [
  {
    topic: 'Getting started',
    items: [
      {
        q: 'How does Routebag work?',
        a: 'Travellers list upcoming journeys with their spare luggage capacity. Senders search those journeys, choose a traveller and pay. Our admin team reviews every request and officially assigns the traveller, then both sides coordinate the handover and delivery on the platform.',
      },
      {
        q: 'Which travel modes are supported?',
        a: 'Flights, trains, buses and road trips. Travellers specify the mode when registering a journey, so senders can pick what suits their item and timeline.',
      },
      {
        q: 'Is Routebag available internationally?',
        a: 'Yes, for routes where travellers list journeys. International deliveries must follow the customs rules of both countries, and the traveller may decline items they are not comfortable declaring.',
      },
    ],
  },
  {
    topic: 'Privacy & safety',
    items: [
      {
        q: 'Can I contact a traveller directly before booking?',
        a: 'No. To protect everyone, senders only see journey details (route, date, travel mode) and available capacity. Contact details are shared only after the admin officially assigns the traveller to your request.',
      },
      {
        q: 'Why does an admin assign the traveller instead of me?',
        a: 'Admin assignment lets us verify the item, the sender and the traveller before anything changes hands. It keeps the platform safe, prevents off-platform deals and makes sure every delivery follows our policies.',
      },
      {
        q: 'How are travellers verified?',
        a: 'Travellers submit a government ID, a selfie holding the ID and proof of address. Our verification team reviews them before a traveller can publish journeys or be assigned requests.',
      },
    ],
  },
  {
    topic: 'Sending',
    items: [
      {
        q: 'What can I send?',
        a: 'Luggage, packages, documents and other permitted personal items. Illegal, hazardous, perishable or restricted goods are not allowed. Every request is screened against our prohibited items list.',
      },
      {
        q: 'When do I pay, and what if my request is not approved?',
        a: 'You pay when you submit your request, and the payment is held by the platform during review. If the request cannot be approved or assigned, you are refunded according to our refund policy.',
      },
      {
        q: 'How does the receiver confirm delivery?',
        a: 'You get a 4-digit delivery code once your request is assigned. Share it only with the receiver. The traveller enters it when handing over the item, which marks the delivery complete.',
      },
    ],
  },
  {
    topic: 'Travelling',
    items: [
      {
        q: 'How do travellers get paid?',
        a: 'Travellers earn for the capacity they share. Earnings are released after the delivery is confirmed.',
      },
      {
        q: 'Can I refuse an item?',
        a: 'Yes. You inspect every item at handover and can refuse it if it does not match the description or you are unsure what is inside. Report it and the admin team handles the request.',
      },
      {
        q: 'What if my travel plans change?',
        a: 'Cancel or edit the journey from your dashboard as early as possible. Any assigned requests go back to the admin team for reassignment. Frequent late cancellations affect your rating.',
      },
    ],
  },
];

const highlights = [faqGroups[1].items[0], faqGroups[1].items[1], faqGroups[2].items[1], faqGroups[2].items[0], faqGroups[3].items[0], faqGroups[0].items[1]];

export function Accordion({ items, defaultOpen = 0 }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="accordion">
      {items.map((f, i) => {
        const isOpen = open === i;
        const id = `faq-${f.q.replace(/\W+/g, '-').toLowerCase()}`;
        return (
          <div className={`acc ${isOpen ? 'is-open' : ''}`} key={f.q}>
            <button className="acc__q" aria-expanded={isOpen} aria-controls={id} onClick={() => setOpen(isOpen ? -1 : i)}>
              <span>{f.q}</span>
              <Plus className="acc__icon" width={20} height={20} />
            </button>
            <div className="acc__a" id={id} role="region">
              <div><p>{f.a}</p></div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default function FAQ() {
  return (
    <section className="section" id="faq">
      <div className="container faq">
        <div className="section__head section__head--left reveal">
          <span className="kicker">FAQ</span>
          <h2>Questions, answered</h2>
          <p>Can't find what you're looking for? See <Link to="/faqs">all FAQs</Link> or <Link to="/contact">talk to our team</Link>.</p>
        </div>
        <div className="reveal"><Accordion items={highlights} /></div>
      </div>
    </section>
  );
}
